export default {
  methods: {
    randomString(length = 7) {
      return Math.random().toString(16).substr(2, length);
    }
  }
}